import {Component, OnInit} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {StripeService} from 'ngx-stripe';
import {Router} from '@angular/router';
import {Globals} from '../../../Globals';
import {HttpService} from '../../../services/http-service';
import { getSignupUserId, patchSignupProgress } from '../signup-user';

@Component({selector: 'app-bank-info', templateUrl: './bank-info.component.html', styleUrls: ['./bank-info.component.scss']})
export class BankInfoComponent implements OnInit {
    globals = Globals;
    isLoadingResults = false;
    rForm: FormGroup;

    constructor(private fb: FormBuilder, private router: Router, private stripeService: StripeService, private service: HttpService) {}

    get rFormControls() {
        return this.rForm.controls;
    }

    ngOnInit() {
        this.stripeService.setKey(this.globals.stripe);
        this.rForm = this.fb.group({
            routingNumber: [
                '',
                [
                    Validators.required, Validators.minLength(9)
                ]
            ],
            bankAccountNumber: ['', Validators.required],
            ssnlast4: ['', Validators.required]
        });
        if (!getSignupUserId()) {
            this.service.showError('Please complete registration first.', 'ERROR');
            this.router.navigate(['/registration/registration-details']);
        }
    }

    goToNextStep() {
        if (this.isLoadingResults || this.rForm.invalid) {
            return;
        }
        const userId = getSignupUserId();
        if (!userId) {
            this.service.showError('Please complete registration first.', 'ERROR');
            this.router.navigate(['/registration/registration-details']);
            return;
        }
        this.isLoadingResults = true;
        const routingNumber = this.rForm.controls['routingNumber'].value;
        const accountNumber = this.rForm.controls['bankAccountNumber'].value;
        const ssnlast4 = this.rForm.controls['ssnlast4'].value;

        // Stripe-validate bank details, then send bankToken so API can create Connect + attach bank
        this.stripeService.createToken('bank_account', {
            country: 'US',
            currency: 'usd',
            routing_number: routingNumber,
            account_number: accountNumber
        }).subscribe(stripeRes => {
            if (!stripeRes.token) {
                this.isLoadingResults = false;
                this.service.showError(
                    (stripeRes.error && stripeRes.error.message) || 'Invalid bank account details',
                    'ERROR'
                );
                return;
            }
            const url = this.globals.urls.signUp.noauth.bankInfo;
            const params = {
                merchantId: userId,
                _id: userId,
                bankToken: stripeRes.token.id,
                routingNumber,
                accountNumber,
                ssnlast4
            };
            this.service.postRequest(url, params).subscribe(res => {
                this.isLoadingResults = false;
                if (res.success === 1) {
                    this.service.showSuccess('Bank Account Added Successfully', 'Bank');
                    patchSignupProgress({ signupStepCompleted: 2 });
                    this.router.navigate(['/registration/insurance-details']);
                } else {
                    this.service.showError(res.message, 'ERROR');
                }
            }, err => {
                this.isLoadingResults = false;
                this.service.showError(typeof err === 'string' ? err : ((err && err.message) || 'Bank save failed'), 'ERROR');
            });
        }, err => {
            this.isLoadingResults = false;
            this.service.showError(typeof err === 'string' ? err : ((err && err.message) || 'Bank validation failed'), 'ERROR');
        });
    }
}
